import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-scenario-excel-dialog',
  templateUrl: './save-scenario-excel-dialog.component.html',
  styleUrls: ['./save-scenario-excel-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SaveScenarioExcelDialogComponent implements OnInit {
  description = '';
  hideClose = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: string, private matDialogRef: MatDialogRef<SaveScenarioExcelDialogComponent>) {}

  public ngOnInit(): void {
    this.description = this.data;
  }

  public save(): void {
    this.matDialogRef.close(true);
  }

  public exit(): void {
    this.matDialogRef.close(false);
  }
}
